import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function useCountries() {
  const client = useApiClientUser()
  return useQuery({
    queryKey: ['countries'],
    queryFn: () =>
      client.user
        .settingsControllerGetCountries({ secure: true })
        .then((res) => res.data.items),
  })
}

export { useCountries }
